package com.anjuros.website.templates.mix.modules

enum class MIXUrlParam(
    val paramName:String
) {
    CATEGORY("cat"),
    SELECTION("sel"),
    STEP("step"),
    LANGUAGE("lang"),
    MODE("mode")
}

const val HintBoxDisplay = "hintBoxDisplay"